import { ArrowRight, Text } from '@doda/io-react/common';
import { createJobRankingUrl } from '@doda/common/src/logics/jobSearchList/createJobRankingUrl';
import { useRef } from 'react';
import { measureJobRankingClick } from '@doda/common/src/logics/jobSearchList/jobRankingAnalytics';
import styles from './index.module.scss';

/**
 * 人気求人ランキングページリンク Props
 * @property label 検索軸のラベル
 * @property queryKey クエリパラメータのキー
 * @property queryValue クエリパラメータの値
 */
interface JobRankingLinkProps {
  label: string;
  queryKey: string;
  queryValue: string;
}

/**
 * 人気求人ランキングページリンク
 */
export const JobRankingLink = ({
  label,
  queryKey,
  queryValue,
}: JobRankingLinkProps) => {
  const isLinkClickedRef = useRef(false);
  const link = createJobRankingUrl(queryKey, queryValue);

  const handleClickLink = () => {
    if (isLinkClickedRef.current) return;
    isLinkClickedRef.current = true;
    measureJobRankingClick();
  };

  return (
    <a href={link} className={styles.jobRankingLink} onClick={handleClickLink}>
      <Text size="16" weight="bold" color="blue">
        {label}の人気求人ランキングを詳しく見る
      </Text>
      <ArrowRight size="M" color="blue" />
    </a>
  );
};
